import React from 'react';
import Heading from '../general/heading/heading.component';
import Card from '../general/card/card.component';
import Grid from '@mui/material/Grid';
import Header from '../general/Headers/Header';
import Footer from '../general/Footer/Footer';

const Resources = () => {
    const list = [
        {
            text: 'Aptitude',
            content:'Links to all aptitude questions',
            index: 0,
            linkTexts:['https://drive.google.com/drive/folders/10-nEPtSVZxtEZC-v9pbugdsOst9-JEs6','https://drive.google.com/drive/folders/30-nEPtSVZxtEZC-v9pbugdsOst9-JEs6']
        },
        {
            text: 'Logical',
            content:'Links to all logical questions',
            index: 1,
            linkTexts:['https://drive.google.com/drive/folders/20-nEPtSVZxtEZC-v9pbugdsOst9-JEs6','https://drive.google.com/drive/folders/30-nEPtSVZxtEZC-v9pbugdsOst9-JEs6']
        },
        {
            text: 'Technical',
            content:'Links to all technical questions',
            index: 2,
            linkTexts:['https://drive.google.com/drive/folders/40-nEPtSVZxtEZC-v9pbugdsOst9-JEs6','https://drive.google.com/drive/folders/50-nEPtSVZxtEZC-v9pbugdsOst9-JEs6']
        },
        {
            text: 'Verbal',
            content:'Links to all verbal questions',
            index: 3,
            linkTexts:['https://drive.google.com/drive/folders/20-nEPtSVZxtEZC-v9pbugdsOst9-JEs6','https://drive.google.com/drive/folders/30-nEPtSVZxtEZC-v9pbugdsOst9-JEs6']
        },
    ];
    return(
        <>
        <Grid container justifyContent="center" spacing={2}>
        <Grid item lg={12}>
        <Header/>
        </Grid>
        <Grid item lg={12}>
        <br/> <br/> <br/>
        <Heading text='Resources' />
        </Grid>
        <Grid container spacing={4} justifyContent="center">
        {
        list.map((item) => (
        <Grid item justifyContent="center">
        <Grid item key={item.index} lg={6} justifyContent="center">
        <Card title={item.text} key={item.index} bigCardDisplay={true} content={item.content} linkTexts={item.linkTexts} />
        </Grid>
        </Grid>
       
        ))
        }
        </Grid>
       
        </Grid>
         <br /><br />
        <Grid item lg={12} >
        <Footer />
        </Grid>
        </> 
    )
}

export default Resources;